import {BsFillLightningFill, BsFillBarChartFill,BsBellFill,BsFillCaretDownFill, BsFillCaretUpFill, BsX,BsCheckLg,BsFillChatRightTextFill , BsArrowUpRightSquareFill, BsFillInfoCircleFill } from 'react-icons/bs'
import {FaUserAlt, FaEdit, FaCommentDots,FaFileInvoice,FaExclamation} from 'react-icons/fa'
import { MdSpaceDashboard, MdDarkMode, MdLightMode, MdPersonAdd, MdPayments, MdCleaningServices, MdDashboardCustomize, MdLocalFireDepartment } from 'react-icons/md'
import {AiTwotoneSetting,AiFillDelete,AiFillPhone} from 'react-icons/ai'
import {FiMenu,FiSearch,FiPlus,FiSend,FiNavigation,FiMail,FiClock,FiUserPlus,FiLogOut} from 'react-icons/fi'
import {ImAttachment, ImProfile } from 'react-icons/im'
import {RxDashboard} from 'react-icons/rx'
import {BiArrowBack} from 'react-icons/bi'
import {RiFileExcel2Fill, RiDeleteBin5Line, RiFileDownloadLine} from 'react-icons/ri'
import {HiDocumentReport} from 'react-icons/hi'
import {HiClipboardDocumentList} from 'react-icons/hi2'

// import {TbReportMoney} from 'react-icons/tb'
export default {
    user : FaUserAlt,
    dashboard: MdSpaceDashboard,
    dashboardCustomize: MdDashboardCustomize,
    settings: AiTwotoneSetting,
    menu: FiMenu,
    search: FiSearch,
    bell: BsBellFill,
    arrowDown: BsFillCaretDownFill,
    arrowUp:BsFillCaretUpFill,
    chart: BsFillBarChartFill,
    lightning: BsFillLightningFill,
    plus:FiPlus,
    attach:ImAttachment,
    send:FiSend,
    delete:AiFillDelete,
    deleteNotFill:RiDeleteBin5Line,
    dark:MdDarkMode,
    light:MdLightMode,
    navigation:FiNavigation,
    dashboardList:RxDashboard,
    edit:FaEdit,
    phone:AiFillPhone,
    mail:FiMail,
    clock:FiClock,
    comments:FaCommentDots,
    addPerson:MdPersonAdd,
    close:BsX,
    addUser:FiUserPlus,
    check:BsCheckLg,
    excel:RiFileExcel2Fill,
    logout:FiLogOut,
    invoice:FaFileInvoice,
    attention:FaExclamation,
    backTo:BiArrowBack,
    report:HiDocumentReport,
    report2:HiClipboardDocumentList,
    note:BsFillChatRightTextFill,
    money:MdPayments,
    download:RiFileDownloadLine,
    arrowRight:BsArrowUpRightSquareFill,
    clean:MdCleaningServices,
    info:BsFillInfoCircleFill,
    profile:ImProfile,
    hot:MdLocalFireDepartment
} 


